/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Associated listing UUID
 * @export
 * @interface ListingId1
 */
export interface ListingId1 {
}

/**
 * Check if a given object implements the ListingId1 interface.
 */
export function instanceOfListingId1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListingId1FromJSON(json: any): ListingId1 {
    return ListingId1FromJSONTyped(json, false);
}

export function ListingId1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingId1 {
    return json;
}

export function ListingId1ToJSON(value?: ListingId1 | null): any {
    return value;
}

